<template>
  <div v-if="showModal">
    <div class="fade modal-backdrop show" @click="close"></div>
    <div
      role="dialog"
      aria-modal="true"
      class="fade modal show"
      tabindex="-1"
      aria-labelledby="contained-modal-title-vcenter"
      style="display: block"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h4">{{title}}</div>
            <button type="button" class="btn-close" aria-label="Close" @click="close"></button>
          </div>
          <div class="modal-body">
            <div class="carousel slide">
              <div class="carousel-inner">

                <swiper :options="swiperOptions" ref="mySwiper" @slideChange="onSlideChange">
                   <swiper-slide v-for="item in imgs" :key="item"><img
                                :src="item"
                                class="img-fluid w-100"
                              /></swiper-slide>
               
                </swiper>


              </div>
              <a
                class="carousel-control-prev"
                role="button"
                tabindex="0"
                href="#"
                ><span
                  aria-hidden="true"
                  class="carousel-control-prev-icon"
                ></span
                ><span class="visually-hidden">Previous</span></a
              ><a
                class="carousel-control-next"
                role="button"
                tabindex="0"
                href="#"
                ><span
                  aria-hidden="true"
                  class="carousel-control-next-icon"
                ></span
                ><span class="visually-hidden">Next</span></a
              >
            </div>
          </div>
          <div class="modal-footer">
            <div class="w-100 row">
              <div class="col" style="flex: 3;padding-right: 0;">
                <button type="button" class="me-2 level-0 btn " :class="[index == 0 ? 'btn-level-0' : 'btn-outline-level-0' ]" @click="goToSlide(0)">
                  0</button
                ><button type="button" class="me-2 btn " :class="[index == 1 ? 'btn-level-1' : 'btn-outline-level-1' ]" @click="goToSlide(1)">
                  1</button
                ><button type="button" class="me-2 btn " :class="[index == 2 ? 'btn-level-2' : 'btn-outline-level-2' ]" @click="goToSlide(2)">
                  2</button
                ><button type="button" class="me-2 btn " :class="[index == 3 ? 'btn-level-3' : 'btn-outline-level-3' ]" @click="goToSlide(3)">
                  3
                </button>
              </div>
              <div class="text-end col" style="padding-right: 0;">
                <button type="button" class="btn btn-secondary" @click="close">关闭</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: "pop-img-slides",
  props: {
    title: {
      type: String,
      default: '标题'
    },
    imgs:{
      type:Array,
      default:()=>[]
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      showModal:false,
      index:0,
      swiperOptions: {
        // Swiper options
        slidesPerView: 1,
        loop:true,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: ".carousel-control-next",
          prevEl: ".carousel-control-prev",
        },
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper  
    }

  },
  methods: {
    open(){
      this.showModal = true
	  this.$nextTick(()=>{
		   this.swiper.update()
	  })
    },
    close(){
	  this.swiper.destroy(false)
      this.showModal = false
	  
    },
    
    goToSlide(index) {
      this.swiper.slideToLoop(index,  500, false) // 参数：索引，动画时间(ms)，是否运行回调函数 
    },
    onSlideChange() {
      // 在slideChange事件中更新当前索引 
      this.index  = this.swiper.realIndex; 
      console.log(' 当前真实索引:', this.index); 
    }
  },
};
</script>

<style scoped="scoped" lang="less">

.btn-blue {
    background-color: #004d97!important;
    color: #fff!important
}

.btn-light-blue {
    background-color: #e4e3dd!important;
    color: #004d97!important
}

.btn-level-0 {
    background-color: #009f12
}

.btn-outline-level-0 {
    border-color: #009f12
}

.btn-level-1 {
    background-color: #fc0
}

.btn-outline-level-1 {
    border-color: #fc0
}

.btn-level-2 {
    background-color: #ff7300
}

.btn-outline-level-2 {
    border-color: #ff7300
}

.btn-level-3 {
    background-color: #ff1313
}

.btn-outline-level-3 {
    border-color: #ff1313
}


</style>
